import React, { useState, useEffect } from 'react';

import './UserQRSInfo.css';
import ListItem from '../../list-items/ListItem';

const UserQRSContent = (props) => {
  switch (props.userQRS) {
    case 'QUERY':
      return(
      <>
        {props.queryLabelData.info && props.queryLabelData.info.map( (item, index) => 
          <ListItem checkdisable={true} handleCheckBox={()=>{}} type={props.queryLabelData.type} key={item.name+index} item={item} index={index} handleClick={props.handleClick} />
        )}
        {props.queryLabelData.nullLabelItem && props.queryLabelData.nullLabelItem.map( (item, index)=> 
          <ListItem checkdisable={true} handleCheckBox={()=>{}} handleClick={props.handleClick} type={props.queryLabelData.nullLabelItemType} key={item.name+index} item={item} index={index} />
        )}
      </>)
    case 'REPORT':
      return(
      <>
        {props.reportLabelData.info && props.reportLabelData.info.map( (item, index) => 
          <ListItem type={props.reportLabelData.type} key={item.name+index} item={item} index={index} handleClick={props.handleClick} />
        )}
        {props.reportLabelData.nullLabelItem && props.reportLabelData.nullLabelItem.map( (item, index) => 
          <ListItem handleClick={props.handleClick} type={props.reportLabelData.nullLabelItemType} key={item.name+index} item={item} index={index} />
        )}
      </>)
    case 'SNAPSHOT':
      return(
      <>
        {props.snapshotLabelData.info && props.snapshotLabelData.info.map( (item, index) => 
          <ListItem type={props.snapshotLabelData.type} key={item.name+index} item={item} index={index} handleClick={props.handleClick} />
        )}
        {props.snapshotLabelData.nullLabelItem && props.snapshotLabelData.nullLabelItem.map( (item, index) => 
          <ListItem handleClick={props.handleClick} type={props.snapshotLabelData.nullLabelItemType} key={item.name+index} item={item} index={index} />
        )}
      </>)
    default:
      return(<></>);
  }
}


const UserQRSInfo = (props) => {
  const [qrsTab, setQRSTab] = useState('QUERY');

  useEffect(()=>{
    setQRSTab('QUERY')
  },[props.selectedUser])

  const UserQRS = () => {
    return [
      {
        qrs: 'QUERY',
      },
      {
        qrs: 'REPORT',
      },
      {
        qrs: 'SNAPSHOT'
      }
    ]
  }
  const UserQRSLabel = ({userQRS}) => {
    switch (userQRS) {
      case 'QUERY':
        return(<>Q</>)
      case 'REPORT':
        return(<>R</>)
      case 'SNAPSHOT':
        return(<>S</>)
      default:
        return(<></>);
    }
  }


  return (
    <div id="userQRSInformation">
      <div className="UserQRSTab">
        {UserQRS().map((item) => {
          
          return(
            <>
              <input id={`qrstab`+item.qrs} type="radio" name="tabs" checked={item.qrs==qrsTab ? true:false} />
              <label id={`qrstab`+item.qrs} onClick={()=>setQRSTab(item.qrs)}>
                <UserQRSLabel userQRS={item.qrs} />
              </label>
            </>
          )
        })}
      </div>
      <div className="UserQRSContent">
        <div className="overflow-component">
          <UserQRSContent handleClick={()=>{}} userQRS={qrsTab} queryLabelData={props.queryLabelData} reportLabelData={props.reportLabelData} snapshotLabelData={props.snapshotLabelData}/>
        </div>
      </div>
    </div>
  )
}

export default UserQRSInfo;